export const imageMap = {
  "images/AutoCheckVHR.png": require("../assets/images/AutoCheckVHR.png"),
  "images/AutoCheckVHR-Unlimited.png": require("../assets/images/AutoCheckVHR-Unlimited.png"),
  "images/BOGO-AutoCheckVHR-Single10.png": require("../assets/images/BOGO-AutoCheckVHR-Single10.png"),
  "images/BOGO-AutoCheckVHR-1010.png": require("../assets/images/BOGO-AutoCheckVHR-1010.png"),
};
